export class ParameterBase<T> {
  value: T;
  key: string;
  label: string;
  required: boolean;
  order: number;
  controlType: string;
  type: string;
  dropdownOptions: any;
  options: {key: string, value: string}[];
  rangeOptions: {startRange: Date, endRange: Date, startTitle: string, endTitle: string};
  format: any;
  showMasterLabel: boolean;

  constructor(options: {
    value?: T;
    key?: string;
    label?: string;
    required?: boolean;
    order?: number;
    controlType?: string;
    type?: string;
    options?: {key: string, value: string}[];
    rangeOptions?: {startRange: Date, endRange: Date, startTitle: string, endTitle: string},
    format?: {}
    showMasterLabel?: boolean,
    dropdownOptions?: any
  } = {}) {
    this.value = options.value;
    this.key = options.key || '';
    this.label = options.label || '';
    this.required = !!options.required;
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType || '';
    this.type = options.type || '';
    this.options = options.options || [];
    this.rangeOptions = options.rangeOptions || undefined;
    this.format = options.format;
    this.showMasterLabel = options.showMasterLabel;
    this.dropdownOptions = options.dropdownOptions;
  }
}
